import moment from 'moment';

const RequestsAdapter = (data) => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const getDirectorStatus = (i) => {
    if (i?.director_approved === 'director_approved_pending') {
      if (moment().isAfter(moment(i?.date_from, 'YYYY-MM-DD'), 'day')) {
        return 'director_approved_expired';
      } else {
        return 'director_approved_new';
      }
    } else {
      return i?.director_approved;
    }
  };

  const getStatus = (i) => {
    if (i?.status === 'director_approved_pending') {
      if (moment().isAfter(moment(i?.date_from, 'YYYY-MM-DD'), 'day')) {
        return 'status_expired';
      } else {
        return 'status_new';
      }
    } else {
      return i?.status;
    }
  };

  const prepareData = (i) => ({
    ...i,
    'shopping_centers.title': i.company?.shopping_center?.title,
    'companies.title': i?.company?.title,
    created_at: moment(i?.created_at).format('DD/MM/YYYY'),
    published: getStatus(i),
    director_approved: getDirectorStatus(i),
  });

  if (Array.isArray(data)) {
    data.forEach((i) => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};

export const FormValuesAdapter = (values) => {
  const formData = new FormData();
  for (let key in values) {
    switch (key) {
      case 'date_to':
      case 'date_from': {
        if (values[key]) {
          formData.append(
            `facility_request[${key}]`,
            values[key].format('YYYY-MM-DD'),
          );
        }
        break;
      }
      case 'time_from':
      case 'time_to': {
        if (values[key]) {
          formData.append(
            `facility_request[${key}]`,
            values[key].format('YYYY-MM-DD HH:mm:00'),
          );
        }
        break;
      }
      case 'external_personal_access': {
        formData.append(`facility_request[${key}]`, values[key] || false);
        break;
      }
      case 'docs': {
        if (values[key] && values[key].length > 0) {
          values[key].forEach((i) => {
            formData.append(`facility_request[${key}][]`, i.originFileObj);
          });
        } else {
          formData.append(`facility_request[${key}]`, []);
        }
        break;
      }
      default: {
        formData.append(`facility_request[${key}]`, values[key] || '');
      }
    }
  }
  return formData;
};

export default RequestsAdapter;
